<template>
    <v-layout class="pl-6" row wrap>
        <v-layout class="mx-0" row wrap v-if="!isOld">
            <confirmation-header-text text="Academic institution" class="ml-2"
                                      icon="mdi-school"></confirmation-header-text>
            <v-flex md3 xs6>
                <list-item-detail
                        :sub_title="application_data.name_of_academic_institution === 'Others'? application_data.name_of_academic_institution +'/' + application_data.other_name_of_academic_institution :application_data.name_of_academic_institution"
                        title="Name of academic institution"/>
            </v-flex>

            <v-flex md3 xs6>
                <list-item-detail
                        :sub_title="application_data.subject"
                        title="Subject"/>
            </v-flex>

            <v-flex md3 xs6>
                <list-item-detail
                        :sub_title="application_data.institute_address"
                        title="Address of institution"/>
            </v-flex>
        </v-layout>
        <v-layout class="mx-0" row wrap v-if="isOld">
            <confirmation-header-text text="Academic institution" class="ml-2"
                                      icon="mdi-school"></confirmation-header-text>
            <v-flex md3 xs6>
                <list-item-detail
                        :sub_title="application_data.academic_name"
                        title="Name of academic institution"/>
            </v-flex>

            <v-flex md3 xs6>
                <list-item-detail
                        :sub_title="application_data.academic_address"
                        title="Address of institution"/>
            </v-flex>

            <v-flex md3 xs6>
                <list-item-detail
                        :sub_title="application_data.study_duration_from+' - '+application_data.study_duration_to"
                        title="Study Duration"/>
            </v-flex>
        </v-layout>
    </v-layout>
</template>

<script>
    import ListItemDetail from "../../ListItemDetail";
    import ConfirmationHeaderText from "../../ConfirmationHeaderText";

    export default {
        computed: {
            application_data() {
                return this.$store.state.VisaRequestSingle.visaRequest.extra.application_data;
            },
            isOld() {
                return this.$store.state.VisaRequestSingle.visaRequest.old;
            },
        },
        components: {
            ListItemDetail, ConfirmationHeaderText
        }
    };
</script>

<style>
</style>
